import { Card } from "antd";
import { Switch, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { type NotificationPreference } from "@src/interface";

function Toggle({ value }: { value: boolean | undefined }) {
  return (
    <>
      <Switch defaultChecked={value} disabled={true}></Switch>
      {value === true ? "ON" : "OFF"}
    </>
  );
}

interface NotificationPreferenceProps {
  notificationPreferences: NotificationPreference;
}

export function NotificationPreference(props: NotificationPreferenceProps) {
  const { notificationPreferences } = props;

  return (
    <Card title="Notification Preferences">
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>Push Notifications</TableCell>
            <TableCell>
              <Toggle value={notificationPreferences.push} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>SMS</TableCell>
            <TableCell>
              <Toggle value={notificationPreferences.sms} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Off</TableCell>
            <TableCell>
              <Toggle value={notificationPreferences.off} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Urgent Shift Notifications</TableCell>
            <TableCell>
              <Toggle value={notificationPreferences.urgentShiftNotification?.isOn} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Priority Access Notifications</TableCell>
            <TableCell>
              <Toggle value={notificationPreferences.priorityAccessPush} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Clipboard Hiring Notifications</TableCell>
            <TableCell>
              <Toggle value={notificationPreferences.placementsMarketingPush} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
}
